<!-- src/layouts/IframeLayout.vue -->
<template>
  <Teleport to="body">
    <RouterView />
  </Teleport>
</template>

<script setup>
import { RouterView } from 'vue-router'
</script>
